"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var core_1 = require("@angular/core");
var meta_condition_1 = require("./meta-condition");
var lodash_1 = require("lodash");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var layout_models_1 = require("../../../../layout-models");
var ConditionUiComponent = /** @class */ (function () {
    function ConditionUiComponent(kbService) {
        this.kbService = kbService;
        this.visibilityObjectChange = new core_1.EventEmitter();
        this._conditionTypes = [];
        this._flatData = [];
    }
    ConditionUiComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._logic = new meta_condition_1.LogicConstruct(this.isSubform);
        this.kbService
            .getMetaFields(this.categoryName)
            .subscribe(function (fields) {
            _this._metaFields = meta_condition_1.acceptableFields(fields);
            lodash_1.values(meta_condition_1.ConditionType).forEach(function (value) {
                return _this._conditionTypes.push(value);
            });
            if (!lodash_1.isNil(_this.controllerModel.visibility)) {
                _this._logic.fromJs(_this.controllerModel.visibility.toJS(), _this.fieldFinder());
            }
            _this.updateFlatData();
        }, console.error);
    };
    Object.defineProperty(ConditionUiComponent.prototype, "metaFields", {
        get: function () {
            return this._metaFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionUiComponent.prototype, "conditionTypes", {
        get: function () {
            return this._conditionTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionUiComponent.prototype, "logic", {
        get: function () {
            return this._logic;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionUiComponent.prototype, "flatData", {
        get: function () {
            return this._flatData;
        },
        enumerable: true,
        configurable: true
    });
    ConditionUiComponent.prototype.fieldFinder = function () {
        var metaFields = this.metaFields;
        return function (systemName) {
            return metaFields.find(function (field) { return field.getSystemName() === systemName; });
        };
    };
    ConditionUiComponent.prototype.handleItemChange = function () {
        this.visibilityObjectChange.emit(this.logic.toJs(this.isSubform));
    };
    ConditionUiComponent.prototype.addToEmpty = function () {
        this.logic.addItemOnEmpty();
        this.triggerChange();
    };
    ConditionUiComponent.prototype.addWithAnd = function (idToAppend) {
        this.logic.addItemWithAnd(idToAppend);
        this.triggerChange();
    };
    ConditionUiComponent.prototype.addWithOr = function (idToAppend) {
        this.logic.addItemWithOr(idToAppend);
        this.triggerChange();
    };
    ConditionUiComponent.prototype.deleteItem = function (id) {
        this.logic.deleteItem(id);
        this.triggerChange();
    };
    ConditionUiComponent.prototype.isLastItem = function (flatLogicItem) {
        if (!lodash_1.isNil(flatLogicItem.conditionItem.parentOperator) &&
            !flatLogicItem.conditionItem.parentOperator.isGroup) {
            return (flatLogicItem.conditionItem.id ===
                lodash_1.last(flatLogicItem.conditionItem.parentOperator.operands).id);
        }
        return false;
    };
    ConditionUiComponent.prototype.isFirstItem = function (flatLogicItem) {
        if (!lodash_1.isNil(flatLogicItem.conditionItem.parentOperator) &&
            !flatLogicItem.conditionItem.parentOperator.isGroup) {
            return (flatLogicItem.conditionItem.id ===
                lodash_1.head(flatLogicItem.conditionItem.parentOperator.operands).id);
        }
        return false;
    };
    ConditionUiComponent.prototype.isLastGroup = function (group) {
        return group.id === lodash_1.last(this._flatData).id;
    };
    ConditionUiComponent.prototype.isConditionNotEmpty = function (condition) {
        return (!lodash_1.isNil(condition.field) &&
            !lodash_1.isNil(condition.conditionType) &&
            !lodash_1.isNil(condition.value) &&
            (!lodash_1.isEmpty(condition.value) || lodash_1.isDate(condition.value)));
    };
    ConditionUiComponent.prototype.addToLast = function (flatLogicItem) {
        if (flatLogicItem.conditionItem.parentOperator.logicType ===
            meta_condition_1.LogicUnitType.AND_OPERATOR) {
            this.logic.addItemWithAnd(lodash_1.last(flatLogicItem.conditionItem.parentOperator.operands).id);
        }
        else {
            this.logic.addItemWithOr(lodash_1.last(flatLogicItem.conditionItem.parentOperator.operands).id);
        }
        this.triggerChange();
    };
    ConditionUiComponent.prototype.addToGroup = function () {
        this.logic.addToGroup();
        this.triggerChange();
    };
    ConditionUiComponent.prototype.isGroupCreated = function () {
        return this.logic.isGroupCreated();
    };
    ConditionUiComponent.prototype.addNewGroupWithAnd = function () {
        this.logic.addNewGroupWithAnd();
        this.triggerChange();
    };
    ConditionUiComponent.prototype.addNewGroupWithOR = function () {
        this.logic.addNewGroupWithOr();
        this.triggerChange();
    };
    ConditionUiComponent.prototype.triggerChange = function () {
        this.updateFlatData();
        this.visibilityObjectChange.emit(this.logic.toJs(this.isSubform));
    };
    ConditionUiComponent.prototype.updateFlatData = function () {
        var _this = this;
        this._flatData.length = 0;
        this.logic.getFlatData().forEach(function (dd) { return _this._flatData.push(dd); });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ConditionUiComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.Language)
    ], ConditionUiComponent.prototype, "currentLanguage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", layout_models_1.ControllerModel)
    ], ConditionUiComponent.prototype, "controllerModel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ConditionUiComponent.prototype, "isSubform", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], ConditionUiComponent.prototype, "visibilityObjectChange", void 0);
    ConditionUiComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'condition-ui',
            template: require('./condition-ui.component.html'),
            styles: [require('./condition-ui.component.css')],
            encapsulation: core_1.ViewEncapsulation.None,
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService])
    ], ConditionUiComponent);
    return ConditionUiComponent;
}());
exports.ConditionUiComponent = ConditionUiComponent;
//# sourceMappingURL=condition-ui.component.js.map